import moment from 'moment';

export const providers = {
  NONE: 'NONE',
  ADYEN: 'ADYEN',
  THALYS: 'THALYS'
};

export const statusShortCode = {
  authorized: 'A',
  failed: 'F',
  initiated: 'I',
  pending: 'P',
  success: 'S'
};

export const status = {
  A: 'payment.authorized',
  F: 'payment.failed',
  I: 'payment.initiated',
  P: 'payment.pending',
  S: 'payment.success'
};

export const codes = {
  CASH: 'Cash',
  CARD: 'CC',
  REFUND: 'refund',
  BACS: 'BACS',
  BUSINESS_ACCOUNT: 'BAF',
  BLUE_VOUCHER: 'Blue_Voucher',
  EVOUCHER: 'Evoucher',
  VOUCHER: 'voucher',
  LOYALTY_POINTS: 'Loyalty_Points',
  WRITE_OFF: 'Writeoff',
  SOCIAL_MEDIA: 'Social_Media',
  APPLE_PAY: 'Applepay',
  PAYPAL: 'Paypal',
  PAPER_VOUCHER: 'Paper_Voucher',
  IDEAL: 'iDeal',
  SOFORT: 'SOFORT',
  GOOGLE_PAY: 'Googlepay',
  KLARNA_BNPL: 'Klarna_BNPL'
};

export const methods = {
  CASH: `${providers.NONE}_${codes.CASH}`,
  CARD: `${providers.NONE}_${codes.CARD}`,
  BACS: `${providers.NONE}_${codes.BACS}`,
  BUSINESS_ACCOUNT: `${providers.NONE}_${codes.BUSINESS_ACCOUNT}`,
  BLUE_VOUCHER: `${providers.NONE}_${codes.BLUE_VOUCHER}`,
  EVOUCHER: `${providers.NONE}_${codes.EVOUCHER}`,
  LOYALTY_POINTS: `${providers.NONE}_${codes.LOYALTY_POINTS}`,
  WRITE_OFF: `${providers.NONE}_${codes.WRITE_OFF}`,
  SOCIAL_MEDIA: `${providers.NONE}_${codes.SOCIAL_MEDIA}`,
  PAPER_VOUCHER: `${providers.NONE}_${codes.PAPER_VOUCHER}`,
  APPLE_PAY: `${providers.NONE}_${codes.APPLE_PAY}`,
  PAYPAL: `${providers.NONE}_${codes.PAYPAL}`,
  IDEAL: `${providers.NONE}_${codes.IDEAL}`,
  SOFORT: `${providers.NONE}_${codes.SOFORT}`,
  GOOGLE_PAY: `${providers.NONE}_${codes.GOOGLE_PAY}`,
  KLARNA_BNPL: `${providers.NONE}_${codes.KLARNA_BNPL}`
};

export const methodsUnavailableForEHL = [
  methods.BUSINESS_ACCOUNT,
  methods.LOYALTY_POINTS,
  methods.BACS,
  methods.BLUE_VOUCHER,
  methods.PAPER_VOUCHER
];

export const methodsUnavailableForEHLWithoutLoyalty = [methods.BUSINESS_ACCOUNT, methods.BACS, methods.BLUE_VOUCHER, methods.PAPER_VOUCHER];

export const paymentMethodTranslation = {
  [codes.CASH]: 'payment.cash',
  [codes.CARD]: 'payment.creditCard',
  [codes.REFUND]: 'payment.refund',
  [codes.BACS]: 'payment.bacs',
  [codes.BUSINESS_ACCOUNT]: 'payment.baf',
  [codes.BLUE_VOUCHER]: 'payment.blue_voucher',
  [codes.EVOUCHER]: 'payment.evoucher',
  [codes.VOUCHER]: 'payment.evoucher',
  [codes.LOYALTY_POINTS]: 'payment.loyalty_points',
  [codes.WRITE_OFF]: 'payment.writeoff',
  [codes.SOCIAL_MEDIA]: 'payment.social_media',
  [codes.PAPER_VOUCHER]: 'payment.paper_voucher',
  [codes.APPLE_PAY]: 'payment.applePay',
  [codes.PAYPAL]: 'payment.payPal',
  [codes.IDEAL]: 'payment.iDeal',
  [codes.SOFORT]: 'payment.SOFORT',
  [codes.GOOGLE_PAY]: 'payment.googlePay',
  [codes.KLARNA_BNPL]: 'payment.klarna'
};

export const paymentMethods = {
  [methods.CASH]: {
    label: 'Cash',
    value: methods.CASH
  },
  [methods.CARD]: {
    label: 'Card',
    value: methods.CARD
  },
  [methods.BACS]: {
    label: 'Bank transfer',
    value: methods.BACS
  },
  [methods.BUSINESS_ACCOUNT]: {
    label: 'Business account',
    value: methods.BUSINESS_ACCOUNT
  },
  [methods.BLUE_VOUCHER]: {
    label: 'Blue voucher',
    value: methods.BLUE_VOUCHER
  },
  [methods.EVOUCHER]: {
    label: 'Evoucher',
    value: methods.EVOUCHER
  },
  [methods.LOYALTY_POINTS]: {
    label: 'Loyalty points',
    value: methods.LOYALTY_POINTS
  },
  [methods.WRITE_OFF]: {
    label: 'Write off',
    value: methods.WRITE_OFF
  },
  [methods.SOCIAL_MEDIA]: {
    label: 'Pay by link',
    value: methods.SOCIAL_MEDIA
  },
  [methods.APPLE_PAY]: {
    label: 'Applepay',
    value: methods.APPLE_PAY
  },
  [methods.PAYPAL]: {
    label: 'PayPal',
    value: methods.PAYPAL
  },
  [methods.IDEAL]: {
    label: 'iDeal',
    value: methods.IDEAL
  },
  [methods.SOFORT]: {
    label: 'SOFORT',
    value: methods.SOFORT
  },
  [methods.PAPER_VOUCHER]: {
    label: 'Paper voucher',
    value: methods.PAPER_VOUCHER
  },
  [methods.GOOGLE_PAY]: {
    label: 'GooglePay',
    value: methods.GOOGLE_PAY
  },
  [methods.KLARNA_BNPL]: {
    label: 'Klarna',
    value: methods.KLARNA_BNPL
  }
};

export const VONAGE_ALLOWED_OFFICES = ['EBSC_GROUPS', 'EBSC_PUBLIC', 'EBSC_STAFF', 'INDIRECT_SALES_TEAM', 'ES_ER_GROUP'];
export const VONAGE_THALYS_ALLOWED_OFFICES = ['CSC_GROUP', 'CSC_PUBLIC', 'CSC_STAFF', 'CSC_ADMIN', 'CSC_SUPER_USER'];

export const types = {
  PAY_BALANCE: 'PAY_BALANCE',
  ON_HOLD_WITH_DEPOSIT: 'ON_HOLD_WITH_DEPOSIT',
  ON_HOLD_NO_DEPOSIT: 'ON_HOLD_NO_DEPOSIT'
};

export const refundSortOrder = [
  methods.CARD,
  methods.PAYPAL,
  methods.APPLE_PAY,
  methods.GOOGLE_PAY,
  methods.KLARNA_BNPL,
  methods.IDEAL,
  methods.SOFORT,
  methods.BUSINESS_ACCOUNT,
  methods.EVOUCHER,
  methods.LOYALTY_POINTS,
  methods.BACS,
  methods.CASH,
  methods.BLUE_VOUCHER,
  methods.SOCIAL_MEDIA,
  methods.WRITE_OFF
];

export const EVOUCHER_DATE_FORMAT = 'YYYY-MM-DD';
export const EVOUCHER_SERVICE_DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
export const MAX_VOUCHER_EXPIRY_DATE = moment().add(12, 'months').format(EVOUCHER_DATE_FORMAT);

export const MAP_LANGUAGE_TO_MARKET = {
  EN: 'uk-en',
  FR: 'fr-fr',
  NL: 'nl-nl'
};
export const MAP_MARKET_TO_LANGUAGE = {
  'uk-en': 'English',
  'fr-fr': 'French',
  'nl-nl': 'Dutch',
  'us-en': 'English'
};
export const VOUCHER_LANGUAGES = ['EN', 'FR', 'NL', 'DE'];

export const COVID_VOUCHER_REFUND = 'Covid voucher refund';

export const businessAccountStatuses = {
  LIVE: 'LIVE',
  SUSPENDED: 'SUSPENDED',
  PENDING: 'PENDING',
  CANCELLED: 'CANCELLED'
};

export const MARGIN_REFUND = 0.02;

export const MONEY_TO_POINTS_CONVERSION_RATE = {
  GBP: 20,
  EUR: 16.66,
  USD: 14.28
};

export const ADDITIONAL_DETAILS_REFUND_KEY_PREFIX = 'REFUND';

export const REFUND_ACTION = 'Refund';

export const RECEIPT_APPROVAL_CODES = {
  APPROVED: 'Approved',
  DECLINED: 'Declined'
};

export const CUSTOMER_PRESENT_OFFICES = [
  'STN_BEBMI',
  'STN_FRLLE',
  'STN_FRPNO',
  'STN_GBASI',
  'STN_GBEBF',
  'STN_GBSPX',
  'STN_NLAMA',
  'STN_NLRTA'
];
